"use client";

import { useVertical } from "@/contexts";
import { HealthcareDashboard, AutomotiveDashboard } from "@/components/dashboard";

const dashboardComponents: Record<string, React.ComponentType> = {
  healthcare: HealthcareDashboard,
  automotive: AutomotiveDashboard,
};

export default function DashboardPage() {
  const { config } = useVertical();

  const DashboardComponent =
    dashboardComponents[config.dashboard.component] || HealthcareDashboard;

  return <DashboardComponent />;
}
